import { render } from "./DisputeDetailModal.vue?vue&type=template&id=4b8c139e&scoped=true"
import script from "./DisputeDetailModal.vue?vue&type=script&lang=js"
export * from "./DisputeDetailModal.vue?vue&type=script&lang=js"

import "./DisputeDetailModal.vue?vue&type=style&index=0&id=4b8c139e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8c139e"]])

export default __exports__